// 全局过滤器


// 处理数字方法
var isNumber = function isNumber(value) {
    return typeof value === 'number' && isFinite(value);
}

var isNumberObject = function isNumberObject(n) {
    return (Object.prototype.toString.apply(n) === '[object Number]');
}

var isCustomNumber = function isCustomNumber(n) {
    return isNumber(n) || isNumberObject(n);
}

const toThousands = num => {
    if (!isCustomNumber(num)) {
        return num;
    }
    let result = [], counter = 0;
    num = (num || 0).toString().split('');
    for (let i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) { result.unshift(','); }
    }
    return result.join('');
}

export {
    toThousands
}


// WEBPACK FOOTER //
// ./src/js/filters.js